import React from 'react';
import { Alert, Box, Button, Typography } from '@mui/material';
import type { StaffingRuleConflictView } from '../../../../services/LaborManagementService/types/laborManagementTypes';

interface StaleRuleSaveAlertProps {
  conflict: StaffingRuleConflictView | null;
  onReload: () => void;
}

// The rule dialog has already closed by the time a refusal lands, so Reload discards nothing and
// asks for no confirmation. There is no "save anyway" here: a refused rule save is never replayed.
const StaleRuleSaveAlert: React.FC<StaleRuleSaveAlertProps> = ({ conflict, onReload }) => {
  if (!conflict) return null;

  return (
    <Alert data-testid="stale-rule-save-alert" severity="warning" sx={{ mb: 2 }}>
      <Typography variant="body2">
        This copy of the staffing rules is out of date. Reload to get the current values, then make your change again.
      </Typography>
      <Box sx={{ mt: 1 }}>
        <Button size="small" sx={{ textTransform: 'none' }} onClick={onReload}>
          Reload
        </Button>
      </Box>
    </Alert>
  );
};

export default StaleRuleSaveAlert;
